/**
 * Inject a separator between each item in a list
 * @param array List of items
 * @param separator Element to be interleaved between each item
 * @returns
 */
export function interleave(array, separator) {
    return array.flatMap((el) => [el, separator]).slice(0, -1);
}
